import styled from 'styled-components';
import { Paper } from '@material-ui/core';
export default styled(Paper) `
  display: flex;
  flex-direction: column;
`;
